/**
 * Who the site is, in one place.
 *
 * The name and the host were written out separately in the renderer, the worker, the
 * build script and the structured data. On screen a stale copy is a typo; on a printed
 * sheet it is a dead address someone typed in by hand, so the print path takes it from
 * here.
 */
export const SITE_NAME = "Nonogram Now";
export const SITE_DOMAIN = "nonogramnow.com";
export const SITE_URL = `https://${SITE_DOMAIN}`;
/** The published contact address. It appears in the policy pages, on /contact and
    in the Organization node, so it is written here rather than four times. */
export const SITE_EMAIL = `support@${SITE_DOMAIN}`;
